import BaseApi from '@core/api/model';

export class IntroducerApi extends BaseApi {
    static resource = 'introducers';
}

export default IntroducerApi;
